import { NavLink } from 'react-router-dom';

import { styled } from '@project44/manifest-ui-deprecated';

export const Container = styled('div')(() => ({
  backgroundColor: '#021C6B',
  display: 'flex',
  flexDirection: 'column',
  padding: '8px 0 20px 0',
  textAlign: 'center',
  width: 60,
  height: '100%',
  zIndex: 1,
}));

export const Divider = styled('hr')(() => ({
  backgroundColor: '#9DAAD9',
  border: 'none',
  height: 1,
  width: 25,
  margin: '0 auto',
}));

export const LinkButton = styled(NavLink)(() => ({
  alignItems: 'center',
  backgroundColor: 'transparent',
  border: '0 none',
  borderRadius: 2,
  display: 'flex',
  color: 'white',
  filter:
    'drop-shadow(0px 4px 16px rgba(255, 255, 255, 0.08)) drop-shadow(0px 4px 4px rgba(255, 255, 255, 0.12)) drop-shadow(0px 0px 8px rgba(255, 255, 255, 0.06))',
  fontSize: 20,
  justifyContent: 'center',
  height: 32,
  lineHeight: 1,
  margin: '16px auto',
  minWidth: 'auto',
  textAlign: 'center',
  transition: 'all 0.2s ease-in',
  width: 32,

  '&:hover': {
    backgroundColor: 'white',
    color: '#005CBE',
  },

  '&.is-active': {
    backgroundColor: 'white',
    color: '#005CBE',
  },
}));

export const AvatarContainer = styled('div')(() => ({
  marginTop: 'auto',
}));

export const Avatar = styled('div')(() => ({
  backgroundColor: 'neutral.100',
  borderRadius: '100px',
  border: '2px solid white',
  boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
  color: 'neutral.400',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  fontSize: 17,
  height: 32,
  overflow: 'hidden',
  margin: '0 auto',
  width: 32,

  '& > img': {
    objectFit: 'cover',
    width: '100%',
  },
}));

export const Logo = styled('img')(() => ({
  marginTop: 'auto',
}));

export const MenuContainer = styled('button')(() => ({
  background: 'transparent',
  border: '0 none',
  cursor: 'pointer',
  position: 'relative',
  padding: 0,
}));
